import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ApplicationState } from "../store";
import { Simulators } from "../store/WorkspaceStore/models";
import { requiresAuthentication } from "./Common";
import NuheatList from "./Nuheat/NuheatList";
import UWG5NventList from "./UWG5Nvent/UWG5NventList";

type Props = ApplicationState;

const SimulationTable = (props: Props) => {
  return (
    <>
      {/* Nuheat */}
      {props.workspace.simulator === Simulators.NuHeat &&
        (props.legacy.NuHeat.thermostats.length > 0 ? (
          <NuheatList />
        ) : (
          <p className="text-center">
            There are no Nuheat thermostats. Go to{" "}
            <Link
              to={{
                pathname: "/wizard/nuheat",
                state: { workspace: props.workspace.focused.id },
              }}
            >
              Create Wizard
            </Link>{" "}
            to create some 😊
          </p>
        ))}
      {/* UWG5 nVent */}
      {props.workspace.simulator === Simulators.UWG5Nvent &&
        (props.uwg5Nvent.thermostats.length > 0 ? (
          <UWG5NventList />
        ) : (
          <p className="text-center">
            There are no UWG5 nVent thermostats. Go to{" "}
            <Link
              to={{
                pathname: "/wizard/uwg5nvent",
                state: { workspace: props.workspace.focused.id },
              }}
            >
              Create Wizard
            </Link>{" "}
            to create some 😊
          </p>
        ))}
    </>
  );
};

export default requiresAuthentication(
  connect((state: ApplicationState) => state)(SimulationTable as any)
);
